import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

const STORAGE_KEY = 'zt_compare_product_ids_v1';
const MAX_ITEMS = 4;

@Injectable({
  providedIn: 'root',
})
export class CompareService {
  private readonly idsSubject = new BehaviorSubject<number[]>(this.readStorage());

  readonly ids$: Observable<number[]> = this.idsSubject.asObservable();

  get ids(): number[] {
    return this.idsSubject.value;
  }

  add(productId: number): boolean {
    const pid = Number(productId);
    if (!pid || pid <= 0) return false;
    const cur = [...this.idsSubject.value];
    if (cur.includes(pid)) return true;
    if (cur.length >= MAX_ITEMS) return false;
    cur.push(pid);
    this.persist(cur);
    return true;
  }

  remove(productId: number): void {
    const pid = Number(productId);
    const cur = this.idsSubject.value.filter((id) => id !== pid);
    this.persist(cur);
  }

  clear(): void {
    this.persist([]);
  }

  has(productId: number): boolean {
    return this.idsSubject.value.includes(Number(productId));
  }

  private persist(ids: number[]): void {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
    } catch {
      /* ignore */
    }
    this.idsSubject.next(ids);
  }

  private readStorage(): number[] {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      const parsed = JSON.parse(raw) as unknown;
      if (!Array.isArray(parsed)) return [];
      return parsed.map((n) => Number(n)).filter((n) => n > 0).slice(0, MAX_ITEMS);
    } catch {
      return [];
    }
  }
}
